import * as XLSX from "xlsx";
import React, { useState, useEffect, useContext, useMemo } from "react";
import Sidebar from "../Components/Sidebar";
import excel from "../assests/images/excel img.png";
import { Link } from "react-router-dom";
import ModalmanagerEdit from "./ModalmanagerEdit";
import CreateManagerForm from "./CreateManagerForm";
import Constant from "../Components/Utils/Constant";
import axios from "axios";
import ReactPaginate from "react-paginate";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { contextProvider } from "../Components/Context";
import EditModelManagerForm from "../Components/models/EditModelManagerForm";
import { useSelector } from "react-redux";

export default function ModelsManager() {
  const { totalCount } = useContext(contextProvider);

  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [showModalmanageForm, setShowModalmanageForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const [showBlockConfirmation, setShowBlockConfirmation] = useState(false);
  const [modelmanager, setModelmanager] = useState([]);
  const [totalCount1, setTotalCount1] = useState(null);
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [dropdownStates, setDropdownStates] = useState(
    Array(modelmanager.length).fill(false)
  );
  const tableRef = React.createRef();
  const [editPopup, setEditPopup] = useState(false);

  // New state to store creator counts for efficient lookup
  const [creatorCounts, setCreatorCounts] = useState({});

  const [modelmanagerToBlock, setModelmanagerToBlock] = useState(null);
  const highlightedId = useSelector((state) => state.DataReducer.highlightedId);
  const [selectedOption, setSelectedOption] = useState("");
  const [createdByFilter, setCreatedByFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("");
  const [sortDirection, setSortDirection] = useState("none");

  // Fetch model counts by creator on component mount
  useEffect(() => {
    const fetchCreatorCounts = async () => {
      try {
        const response = await axios.get(
          `${Constant.BASE_URL}/model/creator-counts`
        );
        if (response.data && response.data.success) {
          // Convert the array response into an object for quick lookups (e.g., { Shivali: 402 })
          const countsMap = response.data.data.reduce((acc, item) => {
            acc[item.creator] = item.count;
            return acc;
          }, {});
          setCreatorCounts(countsMap);
        }
      } catch (error) {
        console.error("Error fetching creator counts:", error);
        toast.error("Could not load model counts.");
      }
    };

    fetchCreatorCounts();
  }, []);

  // Function to handle option selection
  const handleOptionChange = (event, modelmanager) => {
    const selectedValue = event.target.value;
    if (selectedValue === "Edit") {
      setEditPopup(modelmanager);
    } else if (selectedValue === "Delete") {
      handleOpenDeleteConfirmation(modelmanager);
    } else if (selectedValue === "block") {
      handleBlockConfirmation(modelmanager);
    }
  };
  const handleBlockConfirmation = (modelmanager) => {
    setModelmanagerToBlock(modelmanager);
    setShowBlockConfirmation(true);
  };

  const handleConfirmBlock = async () => {
    if (modelmanagerToBlock) {
      try {
        const newBlockStatus = !modelmanagerToBlock.block;
        const response = await axios.put(
          `${Constant.BASE_URL}/modelmanager/update`,
          { block: newBlockStatus, email: modelmanagerToBlock.email }
        );

        if (response.status === 200) {
          setModelmanager((prevManagers) =>
            prevManagers.map((item) =>
              item._id === modelmanagerToBlock._id
                ? { ...item, block: newBlockStatus }
                : item
            )
          );

          toast.success(
            `Model Manager ${
              newBlockStatus ? "Blocked" : "Unblocked"
            } successfully!`
          );
        } else {
          toast.error("Failed to update model manager status.");
        }

        setShowBlockConfirmation(false);
        setModelmanagerToBlock(null);
      } catch (error) {
        console.error("Error updating model manager status:", error);
        toast.error("Failed to update model manager status.");
      }
    }
  };

  const handleCloseBlockConfirmation = () => {
    setShowBlockConfirmation(false);
    setModelmanagerToBlock(null);
  };

  const toggleDropdown = (index) => {
    if (dropdownStates === index) {
      setDropdownStates(null); // Close the dropdown if the same index is clicked
    } else {
      setDropdownStates(index); // Open the clicked dropdown
    }
  };

  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
  };

  const handleCreateManagerClick = () => {
    setShowModalmanageForm(true);
  };

  const handleClosePopup = () => {
    setShowModalmanageForm(false);
  };

  const handleEditAdminClick = () => {
    setShowEditForm(true);
  };

  const handleCloseEdit = () => {
    setShowEditForm(false);
  };

  const handleConfirmation = (confirmationType) => {
    setDropdownStates(false);

    if (confirmationType === "delete") {
      setShowDeleteConfirmation(true);
    } else if (confirmationType === "block") {
      setShowBlockConfirmation(true);
    }
  };

  const handleCloseConfirmation = () => {
    setShowDeleteConfirmation(false);
    setShowBlockConfirmation(false);
  };

  const handleExportToExcel = () => {
    if (tableRef.current) {
      const ws = XLSX.utils.table_to_sheet(tableRef.current);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet 1");
      XLSX.writeFile(wb, "tablexls.xlsx");
    }
  };

  const fetchModelmanager = async (page) => {
    try {
      const response = await fetch(
        `${Constant.BASE_URL}/modelmanager/get?page=${page}`
      );
      const data = await response.json();
      if (data && data.success) {
        setModelmanager(data.modelmanager);
        setTotalCount1(data.totalCount1);
        setTotalPages(data.totalPages);
        setCurrentPage(page);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching model managers:", error);
    }
  };

  useEffect(() => {
    fetchModelmanager(currentPage);
  }, [currentPage, showModalmanageForm, editPopup]);

  // Handle sorting for Model Uploaded column
  const handleSort = () => {
    if (sortDirection === "none") {
      setSortDirection("asc");
    } else if (sortDirection === "asc") {
      setSortDirection("desc");
    } else {
      setSortDirection("none");
    }
  };

  // Filter and sort data using useMemo for efficiency
  const sortedAndFilteredManager = useMemo(() => {
    const filtered = modelmanager
      .filter((a) => (createdByFilter ? a.createdby === createdByFilter : true))
      .filter((a) => {
        if (statusFilter === "blocked") return a.block === true;
        if (statusFilter === "active") return a.block === false;
        return true; // no filter
      });

    // Add modelCount to each manager object using the fetched creatorCounts
    const withCount = filtered.map((manager) => ({
      ...manager,
      modelCount: creatorCounts[manager.name] || 0, // Efficiently get count
    }));

    // Sort if a direction is selected
    if (sortDirection !== "none") {
      withCount.sort((a, b) => {
        if (a.modelCount < b.modelCount) {
          return sortDirection === "asc" ? -1 : 1;
        }
        if (a.modelCount > b.modelCount) {
          return sortDirection === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return withCount;
  }, [modelmanager, creatorCounts, createdByFilter, statusFilter, sortDirection]);

  // unique list of creators
  const uniqueCreators = [...new Set(modelmanager.map((a) => a.createdby))];

  const handlePageClick = ({ selected }) => {
    const newPageNumber = selected + 1;
    fetchModelmanager(newPageNumber);
  };

  const [modelmanagerToDelete, setModelmanagerToDelete] = useState(null);

  const handleOpenDeleteConfirmation = (modelmanager) => {
    setModelmanagerToDelete(modelmanager);
    setShowDeleteConfirmation(true);
  };

  const handleDelete = async () => {
    if (modelmanagerToDelete) {
      try {
        const response = await axios.delete(
          `${Constant.BASE_URL}/modelmanager/delete/${modelmanagerToDelete._id}`
        );
        if (response.status === 200) {
          setModelmanager((prevManagers) =>
            prevManagers.filter((mm) => mm._id !== modelmanagerToDelete._id)
          );
          setModelmanagerToDelete(null);
          setShowDeleteConfirmation(false);
          toast.success("Model Manager deleted successfully!");
        } else {
          toast.error("Failed to delete Model Manager!");
        }
      } catch (error) {
        console.error("Error deleting Model Manager:", error);
        toast.error("Failed to delete Model Manager!");
      }
    }
  };

  // The rest of your JSX remains the same
  return (
    <Sidebar>
      <>
        <ToastContainer />
        <div className="p-3 bg-grey-300 lg:p-3 xl:p-3 2xl:p-6">
          <div
            className="bg-white h-[78.55vh]"
            style={{ borderRadius: "0px 0px 11px 11px" }}
          >
            <div className="flex items-center px-4 py-3 bg-white lg:py-2 xl:py-3 2xl:py-3">
              <div className="flex-1">
                <div className="flex justify-between px-10 lg:w-full lg:px-1 ">
                  <div className="flex ">
                    <div
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #ffffff 0%, #f1f1f1 100%)",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
                      }}
                      className="flex items-center justify-center px-2 py-2  border border-white rounded-md cursor-pointer xl:p-1 2xl:py-3 2xl:px-2 "
                    >
                      <div className="text-4lg 2xl:text-3xl">
                        {" "}
                        <p>
                          Models Manager :
                          {modelmanager ? modelmanager.length : "0"}
                        </p>
                      </div>
                    </div>
                    <Link to="/unitymodels?type=2D&platform=All">
                      <div
                        style={{
                          boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                        }}
                        className="mx-5 px-2 py-2 xl:p-1 flex justify-center items-center bg-white rounded-md border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] 2xl:py-3 2xl:px-2 "
                      >
                        <div className="text-4lg 2xl:text-3xl">
                          {" "}
                          <p> Models </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              {/* Second Box */}
              <div className="flex-1">
                <div className="flex justify-center">
                  <div
                    style={{
                      boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                      zIndex: 3,
                    }}
                    className="cursor-pointer bg-white rounded-sm border border-white border-opacity-60 bg-white bg-opacity-57  backdrop-blur-[5.7px] "
                  ></div>
                </div>
              </div>
              {/* third Box */}
              <div className="flex-1 ">
                <div className="flex justify-end">
                  <div className="flex mx-5 border border-white rounded-md ">
                    <img
                      onClick={handleExportToExcel}
                      src={excel}
                      alt="excel"
                      className="cursor-pointer w-10  2xl:w-[80px] lg:w-[25px] xl:w-[35px]"
                    />
                  </div>

                 <div
                  style={{
                    background:
                      "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                  }}
                  className="lg:w-fit min-w-[160px] px-6 py-2 cursor-pointer flex justify-center items-center rounded-md border border-white border-opacity-60 bg-white bg-opacity-57 backdrop-blur-[5.7px]"
                  onClick={handleCreateManagerClick}
                >
                  <p className="text-center text-sm lg:text-[10px] xl:text-[15px] 2xl:text-[28px] font-semibold">
                    Create Manager
                  </p>
                </div>

                                </div>
                              </div>
                            </div>

            <div className="w-full " style={{ maxWidth: "100%" }}>
              <div className="tablebodydata overflow-y-auto lg:h-[65vh] xl:h-[64vh] 2xl:h-[67vh] relative ">
                <table
                  ref={tableRef}
                  className="table divide-y divide-gray-200 table-hover table-bordered"
                  id="myTable"
                >
                  <thead className="bg-gray-100">
                    <tr>
                      <th>Action</th>
                      <th>Name</th>
                      <th>Phone</th>
                      <th>Email</th>
                      <th>
                        <select
                          value={createdByFilter}
                          onChange={(e) => setCreatedByFilter(e.target.value)}
                          className="ml-2 border px-1 py-0.5 rounded text-sm"
                        >
                          <option value="">Created By</option>
                          {uniqueCreators.map((creator, index) => (
                            <option key={index} value={creator}>
                              {creator}
                            </option>
                          ))}
                        </select>
                      </th>
                      <th>
                        <select
                          value={statusFilter}
                          onChange={(e) => setStatusFilter(e.target.value)}
                          className="ml-2 border px-1 py-0.5 rounded text-sm"
                        >
                          <option value="">Status</option>
                          <option value="active">Active</option>
                          <option value="blocked">Blocked</option>
                        </select>
                      </th>
                      <th onClick={handleSort} className="cursor-pointer">
                        Model Uploaded{" "}
                        {sortDirection === "asc"
                          ? "▲"
                          : sortDirection === "desc"
                          ? "▼"
                          : ""}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {sortedAndFilteredManager.map((modelmanager, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
                        style={{
                          background:
                            highlightedId === modelmanager._id
                              ? "yellow"
                              : "none",
                        }}
                      >
                        <td>
                              <select
                                onChange={(event) => handleOptionChange(event, modelmanager)}
                                value={selectedOption}
                                className="text-xs py-1 px-1 border rounded shadow-sm w-full"
                              >
                                <option value="">Select</option>
                                <option value="Edit">Edit</option>
                                <option value="Delete">Delete</option>
                                <option value="block">
                                  {modelmanager.block ? "Active" : "Block"}
                                </option>
                              </select>
                            </td>


                        <td>{modelmanager.name}</td>
                        <td>{modelmanager.phone}</td>
                        <td>{modelmanager.email}</td>
                        <td>{modelmanager.createdby}</td>
                        <td className="py-4 px-6 whitespace-nowrap">
                          {modelmanager.block ? (
                            <span className="text-black">BLOCKED</span>
                          ) : (
                            <span className="text-green-600">Active</span>
                          )}
                        </td>
                        <td> {modelmanager.modelCount}</td>

                        <div className="flex justify-center ">
                          {/* Delete Confirmation Popup */}
                          {showDeleteConfirmation && (
                            <div className="pop-delete">
                              <div className="flex items-center justify-center w-full ">
                                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md">
                                  <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[500px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">
                                      Do you Want to Delete ?
                                    </div>

                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col py-5 justify-center items-center  lg:text-[10px] xl:text-[13px] 2xl:text-[30px] 2xl:py-12">
                                      <button
                                        type="button"
                                        onClick={() =>
                                          setShowDeleteConfirmation(false)
                                        }
                                        className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm 2xl:px-12"
                                        style={{
                                          boxShadow:
                                            "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                        }}
                                      >
                                        No
                                      </button>
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleDelete(modelmanager._id)
                                        }
                                        className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm 2xl:px-12"
                                        style={{
                                          background:
                                            "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                                        }}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}

                          {/* Block Confirmation Popup */}
                          {showBlockConfirmation && (
                            <div className="pop-delete">
                              <div className="flex items-center justify-center w-full">
                                <div className="p-4 px-1 py-3 bg-white rounded-md shadow-md w-fit">
                                  <div className="lg:w-[280px] xl:w-[280px] 2xl:w-[500px] items-center justify-center">
                                    <div className="mb-4 text-lg font-semibold text-center 2xl:text-4xl 2xl:py-3">
                                      Do you want to{" "}
                                      {modelmanagerToBlock?.block
                                        ? "Active"
                                        : "Block"}
                                      ?
                                    </div>
                                    <hr className="p-2 mt-1" />
                                    <div className="flex flex-col py-5 justify-center items-center lg:text-[10px] xl:text-[13px] 2xl:text-[30px] 2xl:py-12">
                                      <button
                                        type="button"
                                        onClick={handleCloseBlockConfirmation}
                                        className="flex-shrink-0 py-1 bg-white shadow-md text px-7 rounded-sm 2xl:px-12"
                                        style={{
                                          boxShadow:
                                            "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                        }}
                                      >
                                        No
                                      </button>
                                      <button
                                        onClick={() => {
                                          handleConfirmBlock(modelmanager);
                                        }}
                                        className="flex-shrink-0 py-1 mt-5 text-white text px-7 rounded-sm 2xl:px-12"
                                        style={{
                                          background:
                                            "radial-gradient(125% 125% at 85.42% 0%, #FFA6A6 0%, #F00 100%)",
                                        }}
                                      >
                                        Yes
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          {/* Show  create user form  */}
          {showModalmanageForm && (
            <CreateManagerForm onClose={handleClosePopup} />
          )}

          {/* Show  user edit form  */}
          {showEditForm && <ModalmanagerEdit onClosed={handleCloseEdit} />}
        </div>
      </>
      {/* Pagination code*/}
      <div className="flex lg:px-4">
        <div className="w-full  flex  bg-white  bg-white shadow-md backdrop-blur-[5.7px]">
          <div className="w-full  flex  items-center fixed lg:bottom-5 xl:bottom-6 2xl:bottom-6 border-t lg:text-[10px] xl:text-[14px] 2xl:text-3xl lg:pt-1 xl:pt-1 2xl:pt-0">
            <div className="flex justify-start w-full xl:px-5 2xl:p-5">
              <p>
                Showing{" "}
                <span className="text-blue-500">
                  {(currentPage - 1) * 1 + 1}{" "}
                </span>{" "}
                to{" "}
                <span className="text-blue-500">
                  {Math.min(currentPage * 15)}
                </span>{" "}
                of
                <span className="text-yellow-500">{totalCount1} </span> entries
              </p>
            </div>

            {/* pagination code */}
            <div className="flex justify-start pr-2 text-blue-500 pagination xl:pr-5">
              <ReactPaginate
                previousLabel={""}
                nextLabel={"....."}
                breakLabel={"...."}
                pageCount={totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                containerClassName={"pagination"}
                activeClassName={"active"}
                className="flex justify-start"
              />
            </div>
          </div>
        </div>
        {editPopup && (
          <EditModelManagerForm
            editPopup={editPopup}
            setEditPopup={setEditPopup}
          />
        )}
      </div>
    </Sidebar>
  );
}